import backofficeService from '../../api/backoffice'
import publicService from '../../api/public'

export default {
  /**
   * Get list of counters
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   */
  getAll(params) {
    return backofficeService.Api().get('counter', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  /**
   * Get specific counter
   * @param {*} id
   * @param {*} params
   */
  getById(id, params = {}) {
    return backofficeService.Api().get(`counter/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  
  /**
   * Create a counter. Will also initiate location data
   * @param {*} data
   */
  create(data) {
    return backofficeService.Api().post('counter', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Update specific counter
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`counter/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Delete counter
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`counter/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  getPublicCounterList(params) {
    return publicService.Api().get(`/public/counter/info`, {
        params
      })
      .then(response => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

  updateAllPublicCounters(key, data) {
    return publicService.Api().put(`/public/counter/updateAll?key=${key}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  updateById(key, data) {
    return publicService.Api().put(`/public/counter/${data.id}?key=${key}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

}
